<template>
  <div>
    <Header :selectedApp="selectedApp"></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Channels</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input type="text" class="form-control mb-3" placeholder="Search in channels..." v-model="searchText" style="width: 20%; position: relative; ">
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('channelId')">Channel Id</th>
              <th class="col-1" @click="toggleSort('channelName')">Channel Name</th>
              <th class="col-1" @click="toggleSort('eventId')">Event Id</th>
              <th class="col-1" @click="toggleSort('caption')">Caption</th>
              <th class="col-1" @click="toggleSort('protectKey')">Protect Key</th>
              <th class="col-1" @click="toggleSort('tags')">Tags</th>
              <th class="col-1" @click="toggleSort('appName')">Stream App</th>
              <th class="col-1" @click="toggleSort('edgePort')">Stream Port</th>
              <th class="col-1" @click="toggleSort('liveViews')">Live Views</th>
              <th class="col-1" @click="toggleSort('totalViews')">Total Views</th>
              <th class="col-1" @click="toggleSort('providersMetadata')">providersMetadata</th>
              <th class="col-1" @click="toggleSort('orderNumber')">Order Number</th>
              <th class="col-1" @click="toggleSort('status')">Status</th>
              <th class="col-1" @click="toggleSort('active')">Active</th>
             <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.channelId">
              <td class="col-1 text-truncate" v-html="truncateText(config.channelId, 30)"  @click="selectText" :data-text="config.channelId" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.channelName, 30)"  @click="selectText" :data-text="config.channelName" ></td>
              <td class="col-1 text-truncate" @click="selectText" :data-text="formatEventIds(visibleEventIds(config))">{{ formatEventIds(visibleEventIds(config)) }}</td>
              <td class="col-1 text-truncate" v-html="truncateText(config.caption, 30)" @click="selectText" :data-text="config.caption"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.protectKey, 30)" @click="selectText" :data-text="config.protectKey"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.tags, 30)" @click="selectText" :data-text="config.tags"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.appName, 30)" @click="selectText" :data-text="config.appName"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.edgePort, 30)" @click="selectText" :data-text="config.edgePort"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.liveViews, 30)" @click="selectText" :data-text="config.liveViews"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.totalViews, 30)" @click="selectText" :data-text="config.totalViews"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.providersMetadata, 30)" :data-text="config.providersMetadata"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.orderNumber, 30)" @click="selectText" :data-text="config.orderNumber"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.status, 30)" @click="selectText" :data-text="config.status"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.active, 30)" @click="selectText" :data-text="config.active"></td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'ChannelEdit', params: { channelId: config.channelId }, query: selectedApp ? { app: selectedApp } : {} }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import Cookies from "js-cookie";

export default {
  name: "Channels",
  components: {
    Header,
  },
  data() {
    return {
      searchText: '',
      ChannelsList: [],
      sortColumn: '',  // Add this property
      sortDirection: 'asc',
      selectedApp: '',
      // { [eventId]: application } - decides which of a channel's event ids belong to the header's application.
      eventApplicationById: {},
      eventsLoaded: false,
    };
  },
  computed: {
    filteredChannelsList() {
      const search = this.searchText.toLowerCase().trim();
      let filteredList = this.ChannelsList.filter((config) => {
        return (
            (config.channelId && config.channelId.toString().includes(search)) ||
            (config.channelName && config.channelName.toLowerCase().includes(search)) ||
            (this.visibleEventIds(config).some(id => id.toString().includes(search))) ||
            (config.caption && config.caption.toLowerCase().includes(search)) ||
            (config.protectKey && config.protectKey.toLowerCase().includes(search)) ||
            (config.tags && config.tags.toLowerCase().includes(search)) ||
            (config.appName && config.appName.toLowerCase().includes(search)) ||
            (config.edgePort && config.edgePort.includes(search)) ||
            (config.liveViews && config.liveViews.toString().includes(search)) ||
            (config.totalViews && config.totalViews.toString().includes(search)) ||
            (config.providersMetadata && config.providersMetadata.toString().includes(search)) ||
            (config.orderNumber && config.orderNumber.toString().includes(search)) ||
            (config.status && config.status.toString().includes(search)) ||
            (config.active && config.active.toString().includes(search))
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const valueA = a[this.sortColumn];
          const valueB = b[this.sortColumn];

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }
      return filteredList;
    },
    sortData() {
      return this.filteredChannelsList;
    },
  },
  created() {
    const appCookie = Cookies.get('application');
    if (appCookie) {
      this.selectedApp = appCookie;
    }
    this.doLoadChannels();
    this.doLoadEvents();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));

    this.sortColumn = 'channelId';
  },
  methods: {
    doLoadChannels() {
      AdminService.getChannelsList(this.selectedApp).then((data) => {
        this.ChannelsList = data;
      }).catch((error) => {
        console.error("Error loading channels:", error);
      });
    },
    doLoadEvents() {
      AdminService.getEventsList(true).then((events) => {
        const map = {};
        (events || []).forEach((event) => { map[event.eventId] = event.application; });
        this.eventApplicationById = map;
        this.eventsLoaded = true;
      }).catch((error) => {
        console.error("Error loading events:", error);
      });
    },
    // A channel can carry events of several applications; only the header application's ones are shown.
    // "All apps" (no application selected) shows every id.
    visibleEventIds(config) {
      const ids = Array.isArray(config.eventIds) ? config.eventIds : [];
      if (!this.selectedApp) return ids;
      if (!this.eventsLoaded) return [];
      const wanted = String(this.selectedApp).trim().toLowerCase();
      return ids.filter((id) => String(this.eventApplicationById[id] || '').trim().toLowerCase() === wanted);
    },
    formatEventIds(eventId) {
      if (Array.isArray(eventId)) return eventId.length ? eventId.join(', ') : '—';
      return eventId != null ? String(eventId) : '—';
    },
    truncateText(text, limit) {
      if (typeof text === 'string') {
        return text.length > limit ? text.substring(0, limit) + '...' : text;
      } else {
        return String(text).length > limit ? String(text).substring(0, limit) + '...' : String(text);
      }
    },
    redirectToCreate() {
      this.$router.push({ name: 'ChannelCreate' }); // Navigate to the StripeEdit route without params
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    }
  },
};
</script>
<style src="../../assets/style.css">
</style>
